import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ComponentBase } from '../../../../core/_infrastructure/classes/componentBase';
import {
    DocumentoMuestraLaboratorioSolicitudViewModel,
    TwEnvioMuestraLaboratorioSolicitudViewModel,
    EnvioMuestrasLaboratorioSolicitudInspectorViewModel,
    MotivoMuestraLaboratorioSolicitudViewModel,
    MotivoMuestraLaboratorioViewModel,
    ResultadoEnvioMuestraLaboratorioViewModel,
    SolicitudLaboratorioViewModel,
    TwResultadoEnvioMuestraLaboratorioSolicitudViewModel,
    TwTcResultadoEnvioMuestraLaboratorioEnum,
} from '../laboratorio.types';
import { LaboratorioService } from '../laboratorio.service';
import { EnumCodigosTwTcAcciones, EnumIdsTcEstadoSolicitud, EnumIdsTwTcTipoClonacion } from '../../types/enum';
import { RegLaboratorioViewModel } from '../../../../_mantenimiento/registros/laboratorios/laboratorio.types';
import { RegLaboratorioService } from '../../../../_mantenimiento/registros/laboratorios/laboratorio.service';
import { TProductoSolicitudViewModel, TwEmbalajesViewModel } from '../../productos/productos.types';
import { TcPerfilUsuarioEnum } from '../../../../core/_infrastructure/types/common';
import { ConfirmationService } from 'primeng/api';
import { NotificationService } from '../../../../core/_infrastructure/classes/services/notification.service';
import { AuthService } from '../../../../core/_infrastructure/classes/services/auth.service';
import { ExceptionManager } from '../../../../core/_infrastructure/classes/handlers/exceptionManager';
import { NavMenuService } from '../../../../core/components/navmenu/navmenu.service';
import { SolicitudService } from '../../datosbasicos/datosbasicos.service';

@Component({
    selector: 'app-laboratorio-wrapper',
    templateUrl: './laboratorio-wrapper.component.html',
})
export class LaboratorioWrapperComponent extends ComponentBase implements OnInit {
    public isCollapsedCabecera = false;
    visibilitySpinner = false;

    private successMessageInspector = 'Envío de muestras a laboratorio realizado correctamente';
    private successMessageLaboratorio = 'Resultado de muestras enviado correctamente';

    idTipoSolicitud: number;
    tituloTipoSolicitud: string;
    esClonada = false;
    esRechazoParcial = false;

    habilitarEnvioMuestras = false;

    motivosSeleccionados: MotivoMuestraLaboratorioSolicitudViewModel[];
    productosSeleccionados: TProductoSolicitudViewModel[];
    embalajesSeleccionados: TwEmbalajesViewModel[];

    /*Inputs()*/
    idSolicitud = 0;
    solicitudLaboratorio: SolicitudLaboratorioViewModel;
    usuarioId: number | undefined;
    usuarioIdDescripcion = '';
    usuarioAsociadoEnvioId: number | null;
    usuarioAsociadoEnvioDescripcion = '';
    formGroup: FormGroup;
    listLaboratorios: RegLaboratorioViewModel[];
    listMotivos: MotivoMuestraLaboratorioViewModel[];
    listProductos: TProductoSolicitudViewModel[];
    listEmbalajes: TwEmbalajesViewModel[];
    listResultados: ResultadoEnvioMuestraLaboratorioViewModel[];
    listMotivosSolicitud: MotivoMuestraLaboratorioSolicitudViewModel[];
    esPerfilInspectorOrGrabador = false;
    esPerfilConsultasyLaboratorio = false;
    hayEnvioMuestrasInspector = false;
    envioMuestras: TwEnvioMuestraLaboratorioSolicitudViewModel;
    enviandoMuestras = false;
    hayResultadoMuestrasLaboratorio = false;
    resultadoMuestrasLaboratorio: TwResultadoEnvioMuestraLaboratorioSolicitudViewModel;
    envioMuestrasCerrado = false;
    documentosLaboratorio: DocumentoMuestraLaboratorioSolicitudViewModel[];

    private activatedRoute$ = this.activatedRoute.paramMap.subscribe(params => {
        const idSolicitud = params.get('id');
        if (idSolicitud) {
            this.idSolicitud = parseInt(idSolicitud);

            if (this.idSolicitud) {
                this.inicializarDatosLaboratorio();
            }
        }
    });

    constructor(
        protected notificationService: NotificationService,
        private activatedRoute: ActivatedRoute,
        private fb: FormBuilder,
        private router: Router,
        private laboratorioService: LaboratorioService,
        private regLaboratorioService: RegLaboratorioService,
        private confirmationService: ConfirmationService,
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected exceptionHandler: ExceptionManager,
        private navMenuService: NavMenuService,
        private solicitudService: SolicitudService,
    ) {
        super(authService, notificacionService, exceptionHandler);
    }

    private inicializarDatosLaboratorio() {
        this.getSolicitudLaboratorio();
        this.getMotivosMuestraLaboratorioByIdSolicitud();
        this.getDocumentosSolicitudLaboratorio();
    }

    guardRefreshPage(id: number) {
        if ((id && !this.navMenuService.currentSolicitudImportacion.Id) || this.navMenuService.currentSolicitudImportacion.Id !== id) {
            this.solicitudService.getSolicitud(id).subscribe(result => {
                this.navMenuService.currentSolicitudImportacion = result;
            });
        }
    }

    ngOnInit(): void {
        //RDLF: 170325 Ahora el grabador tiene los mismos permisos que el inspector (tarea 166779)
        this.esPerfilInspectorOrGrabador =
            this.isInspector || this.isGrabador;
        this.esPerfilConsultasyLaboratorio =
            this.isConsultas && this.loggedInUser!.hasProfile(TcPerfilUsuarioEnum.Laboratorio);

        this.usuarioId = this.loggedInUser?.Id;
        this.usuarioIdDescripcion = `${this.loggedInUser?.Nombre} ${this.loggedInUser?.Apellidos}`;

        this.guardRefreshPage(this.idSolicitud);

        this.buildForm();

        this.getAllLaboratoriosActivos();

        this.getListMotivosMuestraLaboratorio();

        this.getListResultadosMuestraLaboratorio();
    }

    private buildForm(): void {
        this.formGroup = this.fb.group({
            basic: this.fb.group({
                IdSolicitud: this.idSolicitud, //Not visible
                /*Datos del laboratorio*/
                IdLaboratorio: [null, Validators.required],
                IdLaboratorioEnvioMuestrasSolicitud: [null, Validators.required],
                IdUsuario: [null, Validators.required],
                IdUsuarioDescripcion: ['', Validators.required],
                FechaEnvio: null,
                ObservacionesEnvio: '',
                /*Envío de muestras*/
                IdMotivo: null,
                IdProducto: null,
                IdEmbalaje: null,
                /*Resultado de muestras*/
                IdResultado: [null, Validators.required],
                IdTecnico: [null, Validators.required],
                IdTecnicoDescripcion: '',
                FechaResultado: null,
                ObservacionesResultado: '',
            }),
        });
    }

    onBack() {
        this.enviandoMuestras = false;
    }

    getAllLaboratoriosActivos() {
        this.regLaboratorioService.getAllLaboratoriosActivos().subscribe(res => {
            this.listLaboratorios = res;
        });
    }

    getListMotivosMuestraLaboratorio() {
        this.laboratorioService.getMotivosMuestraLaboratorio().subscribe(res => {
            this.listMotivos = res;
        });
    }

    getMotivosMuestraLaboratorioByIdSolicitud() {
        this.laboratorioService.getMotivosMuestraLaboratorioByIdSolicitud(this.idSolicitud).subscribe(res => {
            this.listMotivosSolicitud = res;
        });
    }

    getListResultadosMuestraLaboratorio() {
        this.laboratorioService.getResultadosMuestraLaboratorio().subscribe(res => {
            this.listResultados = res;
        });
    }

    getSolicitudLaboratorio() {
        this.loading = true;
        this.laboratorioService.getSolicitudLaboratorio(this.idSolicitud).subscribe(res => {
            this.loading = false;
            this.solicitudLaboratorio = res;
            this.idTipoSolicitud = this.solicitudLaboratorio.IdTipoSolicitud;
            this.tituloTipoSolicitud = this.solicitudLaboratorio.IdTipoSolicitudDescripcion;

            this.esClonada =
                this.solicitudLaboratorio.TwSolicitudJerarquia != null &&
                this.solicitudLaboratorio.TwSolicitudJerarquia.IdTipoClonacion == EnumIdsTwTcTipoClonacion.ID_CLONACION
                    ? true
                    : false;
            this.esRechazoParcial = this.solicitudLaboratorio.IdEstadoSolicitud == EnumIdsTcEstadoSolicitud.ID_RECHAZADA_PARCIALMENTE;
            // SI ES RECHAZO PARCIAL SOLO SE LISTAN LOS PRODUCTOS CON LA VARIABLE "DeRechazoParcial" A TRUE
            if (this.esRechazoParcial) {
                this.solicitudLaboratorio.TProductoSolicitudCollection = this.solicitudLaboratorio.TProductoSolicitudCollection.filter(
                    p => p.DeRechazoParcial === true && p.MuestraLaboratorio === true,
                );
            }
            //Si es Re-Importación
            if (this.solicitudLaboratorio.EsReImportacion) {
                this.tituloTipoSolicitud += ' - Re-Importación';
            }
            //Si es previa
            if (this.solicitudLaboratorio.EsPrevia) {
                if (
                    this.solicitudLaboratorio.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_PREVIA_ACEPTADA &&
                    this.solicitudLaboratorio.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_PREVIA_PENDIENTE
                ) {
                    this.tituloTipoSolicitud += ' - Previa';
                }
            }

            this.listProductos = this.solicitudLaboratorio.TProductoSolicitudCollection;
            this.listEmbalajes = this.solicitudLaboratorio.TwEmbalajesCollection;
            this.solicitudLaboratorio.TwTcMotivoMuestraLaboratorioCollection = this.listMotivos;
            this.solicitudLaboratorio.TwMotivoMuestraLaboratorioCollection = this.listMotivosSolicitud;

            this.envioMuestras = res.TwEnvioMuestraLaboratorioSolicitud;
            this.resultadoMuestrasLaboratorio = res.TwResultadoEnvioMuestraLaboratorioSolicitud;

            if (this.envioMuestras) {
                this.enviandoMuestras = false;
                this.hayEnvioMuestrasInspector = true;

                this.usuarioAsociadoEnvioId = this.envioMuestras.IdUsuario;
            }

            if (this.resultadoMuestrasLaboratorio) {
                if (this.resultadoMuestrasLaboratorio.IdTecnico != null && this.resultadoMuestrasLaboratorio.FechaResultado != null) {
                    this.hayResultadoMuestrasLaboratorio = true;
                }
                if (
                    this.hayResultadoMuestrasLaboratorio &&
                    (this.resultadoMuestrasLaboratorio.IdResultado == TwTcResultadoEnvioMuestraLaboratorioEnum.Aceptada ||
                        this.resultadoMuestrasLaboratorio.IdResultado == TwTcResultadoEnvioMuestraLaboratorioEnum.Rechazada)
                ) {
                    this.envioMuestrasCerrado = true;
                }
            }

            this.habilitarEnvioMuestras = this.loggedInUser!.getAction(
                EnumCodigosTwTcAcciones.ENVIO_MUESTRAS_SOLICITUD,
                this.solicitudLaboratorio.IdEstadoSolicitud,
            ).Visible;
        });
    }

    onEnvioMuestras(): void {
        this.confirmationService.confirm({
            message: '¿Está seguro? Se iniciará el proceso de envío de muestras a laboratorio.',
            accept: () => {
                this.enviandoMuestras = true;
            },
        });
    }

    onAddMotivosSelected(motivos: MotivoMuestraLaboratorioSolicitudViewModel[]): void {
        this.motivosSeleccionados = motivos;
    }

    onAddProductosSelected(productos: TProductoSolicitudViewModel[]): void {
        this.productosSeleccionados = productos;
    }

    onAddEmbalajesSelected(embalajes: TwEmbalajesViewModel[]): void {
        this.embalajesSeleccionados = embalajes;
    }

    onSaveEnvioMuestrasInspector(): void {
        if (this.esPerfilInspectorOrGrabador) {
            const model = { ...this.formGroup.value.basic };

            let inspectorEnvioMuestrasModel = new EnvioMuestrasLaboratorioSolicitudInspectorViewModel();

            inspectorEnvioMuestrasModel.TwEnvioMuestraLaboratorioSolicitud.IdSolicitud = this.idSolicitud;
            inspectorEnvioMuestrasModel.TwEnvioMuestraLaboratorioSolicitud.IdLaboratorio = model.IdLaboratorio;
            inspectorEnvioMuestrasModel.TwEnvioMuestraLaboratorioSolicitud.IdUsuario = model.IdUsuario;
            inspectorEnvioMuestrasModel.TwEnvioMuestraLaboratorioSolicitud.FechaEnvio = new Date();
            inspectorEnvioMuestrasModel.TwEnvioMuestraLaboratorioSolicitud.ObservacionesEnvio = model.ObservacionesEnvio;

            inspectorEnvioMuestrasModel.TwMotivoMuestraLaboratorioSolicitud.IdSolicitud = this.idSolicitud;
            inspectorEnvioMuestrasModel.TwMotivoMuestraLaboratorioSolicitud.MotivosCollection = this.motivosSeleccionados;
            inspectorEnvioMuestrasModel.TwMotivoMuestraLaboratorioSolicitud.ProductosCollection = this.productosSeleccionados;
            inspectorEnvioMuestrasModel.TwMotivoMuestraLaboratorioSolicitud.EmbalajesCollection = this.embalajesSeleccionados;

            inspectorEnvioMuestrasModel.TwResultadoEnvioMuestraLaboratorioSolicitud.IdSolicitud = this.idSolicitud;
            inspectorEnvioMuestrasModel.TwResultadoEnvioMuestraLaboratorioSolicitud.IdResultado = TwTcResultadoEnvioMuestraLaboratorioEnum.Pendiente;
            inspectorEnvioMuestrasModel.TwResultadoEnvioMuestraLaboratorioSolicitud.IdTecnico = null;
            inspectorEnvioMuestrasModel.TwResultadoEnvioMuestraLaboratorioSolicitud.FechaResultado = null;
            inspectorEnvioMuestrasModel.TwResultadoEnvioMuestraLaboratorioSolicitud.ObservacionesResultado = '';

            if (!inspectorEnvioMuestrasModel.TwEnvioMuestraLaboratorioSolicitud.IdLaboratorio) {
                this.addErrorMessage('Debe añadir un laboratorio');
                return;
            }
            if (
                inspectorEnvioMuestrasModel.TwMotivoMuestraLaboratorioSolicitud.MotivosCollection == undefined ||
                inspectorEnvioMuestrasModel.TwMotivoMuestraLaboratorioSolicitud.MotivosCollection.length == 0
            ) {
                this.addErrorMessage('Debe añadir un motivo');
                return;
            }
            if (
                (inspectorEnvioMuestrasModel.TwMotivoMuestraLaboratorioSolicitud.ProductosCollection == undefined ||
                    inspectorEnvioMuestrasModel.TwMotivoMuestraLaboratorioSolicitud.ProductosCollection.length == 0) &&
                (inspectorEnvioMuestrasModel.TwMotivoMuestraLaboratorioSolicitud.EmbalajesCollection == undefined ||
                    inspectorEnvioMuestrasModel.TwMotivoMuestraLaboratorioSolicitud.EmbalajesCollection.length == 0)
            ) {
                this.addErrorMessage('Debe añadir al menos un producto o un embalaje');
                return;
            }

            this.confirmationService.confirm({
                message: '¿Está seguro? Una vez se hayan enviado las muestras a laboratorio no será posible su modificación.',
                accept: () => {
                    this.laboratorioService.saveInspectorEnvioMuestras(inspectorEnvioMuestrasModel).subscribe({
                        next: () => {
                            this.addSuccessMessage(this.successMessageInspector);
                            this.inicializarDatosLaboratorio();
                        },
                        error: error => {
                            this.catchServerError(error);
                            this.visibilitySpinner = false;
                        },
                    });
                },
            });
        }
    }

    onSaveResultadoEnvioMuestrasLaboratorio(): void {
        if (this.esPerfilConsultasyLaboratorio) {
            const model = { ...this.formGroup.value.basic };
            let laboratorioResultadoEnvioMuestrasModel = new TwResultadoEnvioMuestraLaboratorioSolicitudViewModel();

            laboratorioResultadoEnvioMuestrasModel.IdSolicitud = this.idSolicitud;
            laboratorioResultadoEnvioMuestrasModel.IdResultado = model.IdResultado;
            laboratorioResultadoEnvioMuestrasModel.IdTecnico = model.IdTecnico;
            laboratorioResultadoEnvioMuestrasModel.FechaResultado = new Date();
            laboratorioResultadoEnvioMuestrasModel.ObservacionesResultado = model.ObservacionesResultado;

            // A pesar de que se envía el array de documentos, no se procesa en el core.
            laboratorioResultadoEnvioMuestrasModel.TwDocumentoMuestraLaboratorioSolicitudCollection = this.documentosLaboratorio;

            if (
                laboratorioResultadoEnvioMuestrasModel.IdResultado == TwTcResultadoEnvioMuestraLaboratorioEnum.Aceptada ||
                laboratorioResultadoEnvioMuestrasModel.IdResultado == TwTcResultadoEnvioMuestraLaboratorioEnum.Rechazada
            ) {
                this.confirmationService.confirm({
                    message: '¿Está seguro? Una vez se haya cerrado el envío de muestras a laboratorio no será posible su modificación.',
                    accept: () => {
                        this.laboratorioService.saveResultadoEnvioMuestrasLaboratorio(laboratorioResultadoEnvioMuestrasModel).subscribe({
                            next: () => {
                                this.addSuccessMessage(this.successMessageLaboratorio);
                                this.visibilitySpinner = false;
                                this.inicializarDatosLaboratorio();
                            },
                            error: error => {
                                this.catchServerError(error);
                                this.visibilitySpinner = false;
                            },
                        });
                    },
                });
            } else {
                this.laboratorioService.saveResultadoEnvioMuestrasLaboratorio(laboratorioResultadoEnvioMuestrasModel).subscribe({
                    next: () => {
                        this.addSuccessMessage(this.successMessageLaboratorio);
                        this.visibilitySpinner = false;
                        this.inicializarDatosLaboratorio();
                    },
                    error: error => {
                        this.catchServerError(error);
                        this.visibilitySpinner = false;
                    },
                });
            }
        }
    }

    onAddDocumento() {
        this.router.navigate([`/importacion/solicitud/laboratorio/${this.idSolicitud}/documento`]);
    }

    getDocumentosSolicitudLaboratorio(): void {
        this.laboratorioService.getDocumentosLaboratorio(this.idSolicitud).subscribe(res => {
            this.documentosLaboratorio = res;
        });
    }

    onDownloadDoc(file: DocumentoMuestraLaboratorioSolicitudViewModel) {
        this.laboratorioService.download(file).subscribe(res => this.OpenDownloadedFile(res));
    }

    onRemoveDoc(doc: DocumentoMuestraLaboratorioSolicitudViewModel): void {
        if (!doc) {
            return;
        }
        this.confirmationService.confirm({
            message: '¿Está seguro?',
            accept: () => {
                //Actual logic to perform a confirmation
                this.laboratorioService.deleteDocumentosLaboratorio(doc.Id!).subscribe(() => {
                    this.addSuccessMessage('Documento eliminado correctamente');
                    this.getDocumentosSolicitudLaboratorio();
                });
            },
        });
    }
}
